import classNames from 'clsx';
import React from 'react';

import useTouchSupported from '@swf/core/hooks/useTouchSupported';

import styles from './RoundPlayButton.scss';

export interface Props {
  title?: string;
  className?: string;

  onClick?(): void;
}

const RoundPlayButton: React.FC<Props> = ({ className, title, onClick }) => {
  const isTouchSupported = useTouchSupported();
  return (
    <button
      data-testid="new-rapid-streams-games-title-list"
      className={classNames(className, styles.playButton, isTouchSupported && styles.touch)}
      onClick={() => onClick && onClick()}
      title={title}
    />
  );
};

export default RoundPlayButton;
